import {
  amazonEcsPlugin,
  EntityAmazonEcsServicesContent,
  isAmazonEcsServiceAvailable,
} from '@aws/amazon-ecs-plugin-for-backstage'
import { convertLegacyPlugin, convertLegacyRouteRef } from '@backstage/core-compat-api'
import { createApp } from '@backstage/frontend-defaults'
import catalogPlugin from '@backstage/plugin-catalog/alpha'
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha'
import { createElement } from 'react'

import { appModule } from './modules/appModule'
import { catalogPageModule } from './modules/catalogPage'

// The Amazon ECS plugin has no New Frontend System (`/alpha`) support yet.
// `EntityAmazonEcsServicesContent` is a legacy *routable* extension bound to the
// plugin's root route, so the entity content must claim that same route (via
// `routeRef`) to satisfy the routable extension's mount point in the app tree.
const amazonEcsContent = EntityContentBlueprint.make({
  name: 'amazon-ecs',
  params: {
    path: '/ecs',
    title: 'Amazon ECS',
    routeRef: convertLegacyRouteRef(amazonEcsPlugin.routes.root),
    filter: isAmazonEcsServiceAvailable,
    loader: () => Promise.resolve(createElement(EntityAmazonEcsServicesContent)),
  },
})

// Registers the legacy plugin's API factories (e.g. amazonEcsApiRef) and routes,
// attaching our native entity content extension to it.
const amazonEcsFeature = convertLegacyPlugin(amazonEcsPlugin, {
  extensions: [amazonEcsContent],
})

const app = createApp({
  features: [catalogPlugin, appModule, catalogPageModule, amazonEcsFeature],
})

export default app.createRoot()
